import {themeColors} from '../../theme/Theme';

const styles = (theme: any) => ({
  root: {},
  infoBox: {
    border: `1px solid ${themeColors.coral}`,
    padding: '18px 40px',
    maxWidth: 630,
    margin: '30px auto 0',
    display: 'flex',
    alignItems: 'center',
    gap: 20,
  },
  infoBoxText: {},
  errorIconContainer: {
    backgroundColor: themeColors.coral,
    width: 63,
    height: 63,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorIcon: {},
});

export default styles;
